"use strict";

var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = void 0 && (void 0).__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
function __export(m) {
  for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
var secp256k1_1 = require("secp256k1");
var random_1 = require("./random");
var SECP256K1_PRIVATE_KEY_SIZE = 32;
function createPrivateKey() {
  return __awaiter(this, void 0, void 0, function () {
    var pk;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!true) return [3 /*break*/, 2];
          return [4 /*yield*/, random_1.getRandomBytes(SECP256K1_PRIVATE_KEY_SIZE)];
        case 1:
          pk = _a.sent();
          if (secp256k1_1.privateKeyVerify(pk)) {
            return [2 /*return*/, pk];
          }
          return [3 /*break*/, 0];
        case 2:
          return [2 /*return*/];
      }
    });
  });
}

exports.createPrivateKey = createPrivateKey;
function createPrivateKeySync() {
  while (true) {
    var pk = random_1.getRandomBytesSync(SECP256K1_PRIVATE_KEY_SIZE);
    if (secp256k1_1.privateKeyVerify(pk)) {
      return pk;
    }
  }
}
exports.createPrivateKeySync = createPrivateKeySync;
__export(require("secp256k1"));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7QUFDQTtBQUVBLElBQU1BLDBCQUEwQixHQUFHLEVBQUU7QUFFckMsU0FBc0JDLGdCQUFnQjs7Ozs7O2VBQzdCLElBQUk7VUFDRSxxQkFBTUMsdUJBQWMsQ0FBQ0YsMEJBQTBCLENBQUM7O1VBQXJERyxFQUFFLEdBQUdDLFNBQWdEO1VBQzNELElBQUlDLDRCQUFnQixDQUFDRixFQUFFLENBQUMsRUFBRTtZQUN4QixzQkFBT0EsRUFBRTs7Ozs7Ozs7OztBQUpmRztBQVNBLFNBQWdCQyxvQkFBb0I7RUFDbEMsT0FBTyxJQUFJLEVBQUU7SUFDWCxJQUFNSixFQUFFLEdBQUdELDJCQUFrQixDQUFDRiwwQkFBMEIsQ0FBQztJQUN6RCxJQUFJSyw0QkFBZ0IsQ0FBQ0YsRUFBRSxDQUFDLEVBQUU7TUFDeEIsT0FBT0EsRUFBRTs7O0FBR2Y7QUFQQUc7QUFTQUUiLCJuYW1lcyI6WyJTRUNQMjU2SzFfUFJJVkFURV9LRVlfU0laRSIsImNyZWF0ZVByaXZhdGVLZXkiLCJyYW5kb21fMSIsInBrIiwiX2EiLCJzZWNwMjU2azFfMSIsImV4cG9ydHMiLCJjcmVhdGVQcml2YXRlS2V5U3luYyIsIl9fZXhwb3J0Il0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNyYy9zZWNwMjU2azEudHMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=